import {useState} from 'react'

type Validator<ValidationError> = (value: string) => ValidationError

interface FormField<ValidationError> {
  value: string
  touched: boolean
  validationError?: ValidationError
}

export function useFormField<ValidationError>(
  initialValue: string,
  options?: {validator?: Validator<ValidationError>},
) {
  const [field, updateField] = useState<FormField<ValidationError>>({
    touched: false,
    value: initialValue,
  })

  function touch() {
    updateField({...field, touched: true})
  }

  function update(value: string, {shouldValidate}: {shouldValidate?: boolean} = {}) {
    updateField({
      ...field,
      value,
      touched: true,
      validationError: shouldValidate ? options?.validator?.(value) : field.validationError,
    })
  }

  function validate() {
    const validationError = options?.validator?.(field.value)
    updateField({...field, validationError})

    return validationError
  }

  function reset() {
    updateField({touched: false, value: initialValue})
  }

  function isValid() {
    return !field.validationError
  }

  return {
    ...field,
    touch,
    validate,
    update,
    reset,
    isValid,
  }
}
